import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export { CircularProgress, CircularProgressProps };
